import {CreateAccessToken, ConsentArgs, Region} from "platformed-client/types";
import {platformedClient} from ".";

export async function create(clientRegion: Region, accessToken: CreateAccessToken) {
  return await platformedClient.internalRequest("post", `/region/{region}/api/access_tokens`, {
    body: accessToken,
    path: {region: clientRegion},
  });
}

export async function consent(args: ConsentArgs) {
  return await platformedClient.internalRequest("get", "/api/consent", {query: args});
}
